import React from 'react';
import styles from "./styles.module.scss";
import Ok from "../Icons/Common/Ok";
import useTranslation from "next-translate/useTranslation";
import {COMMON_NAMESPACE} from "../../../../utils/i18nNameSpaces";

const Index = () => {
  const {t} = useTranslation(COMMON_NAMESPACE)
  return (
    <div className={styles["success"]}>
      <div className={styles["success__ok-wrapper"]}>
        <Ok/>
      </div>
      <strong><p className={styles["success__text"]}>{t(`ticket.send.success`)}</p></strong>
    </div>
  );
};

export default Index;